module.exports = __webpack_public_path__ + "img/mmohub.com.b6310b25.jpg";